export default __webpack_public_path__ + "static/media/tent.f06db705.jpg";